/**
 * Filter for company Name it the name is too long
 */
const filter = () => {
    return (input) => {
        var output = input;
        if (output.length > 32) {
            return output.substring(0, 32) + "...";
        }
        else {
            return output;
        }
    };
};
const ɵ0 = filter;
export const CompanyNameSettingFilter = {
    name: 'companyNameSettingFilter',
    filter: filter
};
export { ɵ0 };
//# sourceMappingURL=fourdotfive-company-name-setting.filter.js.map